const styles = (theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		pb: 4,
	},
	header: {
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
	},
	titulo: {
		color: theme.palette.text.primary,
	},
	subtitulo: {
		color: theme.palette.text.secondary,
		fontSize: "0.95rem",
	},
	blocoCheio: {
		width: "100%",
	},
	// Aviso de alertas omitidos pela configuração de exibição.
	avisoOcultos: {
		alignItems: "center",
		borderRadius: "10px",
		"& .MuiAlert-action": {
			pt: 0,
			alignItems: "center",
		},
	},
	// Filhos do grid ocupam a altura total da linha para os Papers alinharem.
	itemAlturaTotal: {
		height: "100%",
		"& > *": { height: "100%" },
	},
	// Linha Timeline global + Alertas inteligentes: altura fixa compartilhada
	// para os dois Papers ficarem do mesmo tamanho e cada feed rolar por
	// dentro (sem o bloco mais alto esticar o vizinho).
	// Fila de ação + Eventos recentes lado a lado (teto de 500px em cada
	// card, no styles.js deles); empilha abaixo de lg.
	linhaFila: {
		width: "100%",
		display: "grid",
		gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1fr) 360px" },
		gap: 1,
	},
	itemAlturaFeeds: {
		height: { xs: "560px", md: "660px" },
		"& > *": { height: "100%" },
	},
});

export default styles;
